import React, { forwardRef, useEffect } from 'react';
import {
    Alert,
    Box,
    Button,
    IconButton,
    Snackbar,
    Typography,
} from '@mui/material';

import { useSnackbar, SnackbarContent } from 'notistack';

const BaseSnackbar = forwardRef((props, ref) => {
    const { variant, message, id } = props

    const { closeSnackbar } = useSnackbar();

    return (
        <SnackbarContent ref={ref} role='alert'>
            <Box
                {...props}
                width='350px'
            >
                <Alert
                    severity={variant}
                    onClose={() => closeSnackbar(id)}
                >
                    {message}
                </Alert>
            </Box>
        </SnackbarContent>
    );
})

export default BaseSnackbar;